"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("@trs/utils");
var _general = require("@trs/utils/lib/general");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StyledCurrency = _styledComponents["default"].span.withConfig({
  displayName: "Currency__StyledCurrency",
  componentId: "sc-r9pjfk-0"
})(["span{font-weight:normal;}"]);
StyledCurrency.displayName = 'StyledCurrency';
// locale mappings can be found here https://github.com/mozilla/language-mapping-list/blob/master/language-mapping-list.js
/**
 * Helper to convert currency with locale
 * @param {string|number} value - can be provided as string or number, we'll asume string and do parsefloat
 * @param {string} currency - currency, provided as code GBP, RON, USD etc.
 * @param {string} [locale=undefined] - locale, if not provided it will use system/browser locale
 */
var currencyParser = function currencyParser(value, currency, locale, decimals, shouldParseFloat) {
  var amount = shouldParseFloat ? parseFloat(value, 10) : (0, _utils.floor)(value);
  if (!amount && amount !== 0) return amount;
  // toLocaleString is supported across all browsers except android webview - should be ok
  var defaultOptions = {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  };
  var options = _objectSpread({}, defaultOptions);
  if (currency) options.currency = currency;
  return currency === '%' ? (0, _general.formatNumber)(parseFloat(amount).toFixed(decimals), undefined) : (0, _general.formatNumber)(parseFloat(amount).toFixed(decimals), locale);
};
var Currency = function Currency(_ref) {
  var children = _ref.children,
    currency = _ref.currency,
    locale = _ref.locale,
    decimals = _ref.decimals,
    shouldParseFloat = _ref.shouldParseFloat,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledCurrency, {
    className: "currency ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("strong", null, currencyParser(children, currency, locale, decimals, shouldParseFloat)), currency && /*#__PURE__*/_react["default"].createElement("span", null, " ", currency));
};
Currency.propTypes = {
  shouldParseFloat: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  currency: _propTypes["default"].string,
  locale: _propTypes["default"].string,
  decimals: _propTypes["default"].number,
  className: _propTypes["default"].string
};
Currency.defaultProps = {
  shouldParseFloat: false,
  locale: undefined,
  children: '0',
  currency: 'GBP',
  decimals: 0,
  className: 'currency-wrapper'
};
var _default = exports["default"] = Currency;